/* eslint-disable @typescript-eslint/no-unused-vars */
import { ProfileDashed } from './components/ProfileDashed/ProfileDashed'
import { EventItem, NextEvents } from './components/NextEvents/NextEnvents'
import { MenuButton } from './components/MenuButton/MenuButton'
import { BsInboxes } from 'react-icons/bs'
import { IoGitPullRequestOutline } from "react-icons/io5";
import './dashed.scss'
import './components/ProfileDashed/profiledashed.scss'
import { BannerDashed } from './components/BannerDashed/BannerDashed'
import useDashed from './hooks/useDashed'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { MenuOptions } from './components/MenuOptions/MenuOptions'
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AbstractAccount, _single } from '../../../../core/services/dataBean/EntityCatalog';
import { FileService } from '../../../../core/services/FileService';
import { Modal } from '../../../theme/Component/Modal';
import { FileInput } from '../../../theme/Component/FileInput';


export interface DashData {
    greetings: string,
    name: string
}


export const events: EventItem[] = []

export const Dashed = () => {
    const absAcco = useDataBean(_AbstractAccount);
    const [user, setUser] = useState<any>(_single.getAccount())
    const fileService = new FileService();
    const [image, setImage] = useState<string>(null)
    const navigate = useNavigate();
    const { renderSwitch, example, activeQA, setActiveQA } = useDashed();
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [innerW, setInnerW] = useState<number>(window.innerWidth)

    useEffect(() => {
        const x = _single.getAccount();
        if (x.Photo) {
            let photo = fileService.getUrlFile("photos", x.Photo);
            setImage(photo);
            _single.accountPhoto = photo;
        } else {
            setImage("assets/images/core/avatar.png")
        }
    }, [modal.view])

    const updatePhoto = () => {
        absAcco.instance.updateAbstractAccount(user).then(
            (resp) => {

                setModal({ ...modal, "view": false })
                _single.startSesion(user)
                window.location.reload();
            }
        )
    }

    useEffect(() => {
        const handleResize = () => {
            setInnerW(window.innerWidth)
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [window.innerWidth])

    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-7">
                        <div className="main_info animate__animated animate__fadeInDown" style={{ minHeight: "300px" }}>
                            <ProfileDashed user={user} imgProfile={image} changeProfileImg={() => { setModal({ ...modal, "view": true, "name": "Cambio de Imagen de Perfil" }) }}>
                                <div className='d-flex gap-2 w-100'>
                                    <MenuButton item={{
                                        label: 'Bandeja',
                                        icon: <BsInboxes />,
                                        event: () => { navigate("/app/bpm/ibox2") }
                                    }} iconSize={50} labelSize={16} />
                                    <MenuButton item={{
                                        label: 'Mis Solicitudes',
                                        icon: <IoGitPullRequestOutline />,
                                        event: () => { navigate("/app/admin/user-inbox") }
                                    }} iconSize={50} labelSize={16} />
                                </div>
                            </ProfileDashed>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className=" animate__animated animate__fadeInRight" style={{ paddingTop: innerW < 766.93 ? "37px" : "" }}>
                            <NextEvents events={events} />
                        </div>
                    </div>
                    {/* <div className="col-md-4">
                        <div className="">
                            <MenuDashed quick_actions={example} />
                        </div>
                    </div> */}

                    <div className="col-xl-3">
                        <MenuOptions quick_actions={example} />
                    </div>
                    <div className="col-xl-9">
                        <div className="" style={{ boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)", borderRadius: "20px" }}>
                            {activeQA &&
                                <>
                                    <BannerDashed quickAction={activeQA} />
                                    <div className="row py-5 p-5" >
                                        <div className="col-md-12">
                                            {renderSwitch()}
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={() => { updatePhoto() }} >
                    <div className="row d-flex justify-content-center">
                        <div className="col-8">
                            <FileInput
                                Media={user.Photo}
                                MediaContext={'photos'}
                                directory='photos'
                                previsualization
                                label='Nueva Imagen'
                                onCreate={(e) => { setUser({ ...user, "Photo": e.Media }); }}
                                docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml" />
                        </div>
                    </div>
                </Modal>
            }
        </>
    )
}
